<div class="d-flex flex-row align-items-center justify-content-center h-100">
  <div class="content d-flex flex-column align-items-center text-center">
    <rs-web-whitelabel-image
      [whitelabelImage]="WhitelabelImage.ERROR"
      [altTag]="WhitelabelImageAltTag.ERROR | translate"
      [onSurface]="true"
    ></rs-web-whitelabel-image>
    <ng-content></ng-content>
  </div>
</div>
